import React, { FC, useCallback, useEffect, useRef, useState } from 'react'
import { Text } from '@sitecore-jss/sitecore-jss-react'
import { HistoryTabsProps } from './types/HistoryTabs.types'
import './HistoryTabs.scss'

const HistoryTabs: FC<HistoryTabsProps> = ({
  index,
  tabs,
  borderTop,
  setIndex,
  setTab,
  onScroll,
}) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const [suggestScroll, setSuggestScroll] = useState<boolean>(false)

  const updateSuggestedScroll = useCallback(() => {
    setSuggestScroll(
      !!(scrollRef.current && (scrollRef.current.scrollWidth - scrollRef.current.clientWidth > 100))
    )
  }, [])

  useEffect(() => {
    updateSuggestedScroll()

    window && window.addEventListener('resize', updateSuggestedScroll)
    scrollRef.current?.addEventListener('scroll', () => setSuggestScroll(false))
    return () => {
      window && window.removeEventListener('resize', updateSuggestedScroll)
      scrollRef.current?.addEventListener('scroll', () =>
        setSuggestScroll(false)
      )
    }
  }, [tabs, updateSuggestedScroll])

  return (
    <section
      className={'HistoryTabs__wrapper'}
      style={
        borderTop
          ? {
              borderTop: '2px solid #e41e2d',
              borderBottom: 'none',
              paddingTop: '10px',
            }
          : {}
      }
    >
      <div className="HistoryTabs__wrapper_scroll" ref={scrollRef}>
        <div>
          {tabs.map((tab, idx) => {
            return (
              <Text
                tag="p"
                key={idx}
                className={`HistoryTabs__tab ${idx === index ? 'active' : ''}`}
                onClick={() => {
                  setIndex(idx)
                  setTab(tabs[idx])
                  onScroll()
                }}
                field={{
                  value: tab,
                }}
              />
            )
          })}
        </div>

        {suggestScroll && (
          <span className="HistoryTabs__scroll_suggest">
            <div />
            <div />
          </span>
        )}
      </div>
    </section>
  )
}

export default HistoryTabs
